export class UnableToReadTokenError extends Error {
}